import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { contentAPI } from "../api/endpoints";
import { useAuth } from "../context/AuthContext";
import LiveTvModal from "../components/LiveTvModal";
import LoginPromptModal from "../components/LoginPromptModal";

export default function LiveTv() {
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const [streamUrl, setStreamUrl] = useState("");
  const [channelName, setChannelName] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    contentAPI
      .getHome()
      .then((res) => {
        const sections = res.data || [];
        const liveTvSection = sections.find(
          (s) => s.type === "livetv"
        );

        if (liveTvSection) {
          const firstItem = liveTvSection.data?.[0];
          if (firstItem?.link) {
            setStreamUrl(firstItem.link);
            setChannelName(firstItem.name || firstItem.title || liveTvSection.title || "The Slay Network Live");
          }
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (!isLoggedIn) {
    return (
      <div className="min-h-screen bg-black">
        <LoginPromptModal show onClose={() => navigate(-1)} />
      </div>
    );
  }

  if (loading) {
    return (
      <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90">
        <div className="w-10 h-10 border-3 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <LiveTvModal
      streamUrl={streamUrl}
      channelName={channelName}
      onClose={() => navigate(-1)}
    />
  );
}
